module.exports = __webpack_public_path__ + "media/bandunqi.c09f8f2c.mp4";